import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ArrowUp } from 'lucide-react';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const [showButton, setShowButton] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      const open = Boolean(e?.detail?.open);
      setChatOpen(open);
    };
    window.addEventListener('libsys-chat-open', handler);
    return () => window.removeEventListener('libsys-chat-open', handler);
  }, []);

  useEffect(() => {
    try {
      if (typeof window.scrollTo === 'function') {
        window.scrollTo(0, 0);
      }
    } catch (e) {
      // In test environments (jsdom) scrollTo may not be implemented.
    }
  }, [pathname]);

  useEffect(() => {
    let rafId = 0;

    const onScroll = () => {
      if (rafId) return;
      rafId = window.requestAnimationFrame(() => {
        rafId = 0;
        setShowButton(window.scrollY > 600);
      });
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return showButton ? (
    chatOpen ? null : (
      <button
        type="button"
        aria-label="Scroll to top"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-6 right-24 z-40 w-12 h-12 rounded-full bg-white text-primary border border-slate-200 shadow-lg hover:bg-slate-50 transition-colors flex items-center justify-center"
      >
        <ArrowUp className="w-6 h-6" />
      </button>
    )
  ) : null;
};

export default ScrollToTop;
